import React from 'react'
import tic from "../../assets/images/tic.png"
const Mission = () => {
  return (
    <div className='pt-14 px-8 grid justify-center'>
      <div className='grid justify-center text-center gap-6'>
        <h1 className='text-4xl text-[#54B3FF] font-semibold'>Mission du</h1>
        <h2 className='gabriel text-5xl text-[#006DC4] uppercase'>L'Observatoire </h2>
        <p className='text-[#5A5A5A] text-lg'>The observatory is responsible for the following tasks:</p>
      </div>
      <div className='grid grid-cols-1 md:grid-cols-2 mt-20 p-8 w-full gap-12 md:gap-24'>
        <div className='flex align-top h-24 max-w-[505px]'>
          <img src={tic} alt='task' className='h-[108px] w-[108px]' />
          <p>Periodic monitoring of the water pollution levels from Oued El Bey.</p>
        </div>
        <div className='flex align-top h-24 max-w-[505px]'>
          <img src={tic} alt='task' className='h-[108px] w-[108px]' />
          <p>Identification of water issues, control, and hydrological monitoring in the "Sebkhet" wetland.</p>
        </div>
        <div className='flex align-top h-24 max-w-[505px]'>
          <img src={tic} alt='task' className='h-[108px] w-[108px]' />
          <p>Organization of work meetings among members to create innovative and sustainable solutions to water pollution issues in Oued El Bey.</p>
        </div>
        {/* <div className='flex align-top h-24 max-w-[505px]'>
          <img src={tic} alt='task' className='h-[108px] w-[108px]' />
          <p>Identification of water issues, control, and hydrological monitoring in the "Sebkhet" wetland.</p>
        </div> */}
      </div>
    </div>
  );
  
}

export default Mission